import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { allIcons, allImages } from "../../../assets";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import appcolors from "../../../constants/Colors";
import globalStyle from "../../../globalStyle";
import GlobalButton from "../../../components/CustomButton";

const EnableOnlineBookings = ({
  type,
  inputValues,
  setInputValues,
  handleCreateBranch,
}) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  return (
    <Box sx={{ margin: "20px 40px" }}>
      <Grid container spacing={4} justifyContent={"center"}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "35px", margin: "0 0 20px" }}
          >
            Enable online bookings
          </Typography>
          <Typography variant="h3" sx={{ fontWeight: "700", fontSize: "17px" }}>
            Payment method
          </Typography>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              marginTop: "3px",
              marginBottom: "10px",
              color: "#848886",
            }}
          >
            Choose how you would like to pay for the add-on
          </Typography>

          <Label
            labelText="Card holder full name"
            labelProps={{ color: appcolors.black, fontWeight: 600 }}
          />
          <TextInput
            required
            placeholder="Card holder full name"
            type="text"
            name="cardHolderName"
            value={inputValues.cardHolderName}
            onChange={handleChange}
            style={{ marginBottom: "20px" }}
          />

          <Label
            labelText="Card number"
            labelProps={{ color: appcolors.black, fontWeight: 600 }}
          />
          <TextInput
            required
            placeholder="Credit or debit card number"
            type="number"
            name="cardNumber"
            value={inputValues.cardNumber}
            onChange={handleChange}
            style={{ marginBottom: "20px" }}
            maxLength={16}
            InputEndIcon={
              <img
                src={allImages.visaMasterImage}
                style={{ width: "25%", height: "100%", marginLeft: "auto" }}
              />
            }
          />

          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Label
                labelText="Expiry date"
                labelProps={{ color: appcolors.black, fontWeight: 600 }}
              />
              <TextInput
                required
                placeholder="MM/YY"
                name="expiryDate"
                value={inputValues.expiryDate}
                onChange={handleChange}
                style={{ marginBottom: "20px" }}
                maxLength={6}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Label
                labelText="CVV"
                labelProps={{ color: appcolors.black, fontWeight: 600 }}
              />
              <TextInput
                required
                placeholder="123"
                type="number"
                name="cvv"
                value={inputValues.cvv}
                onChange={handleChange}
                style={{ marginBottom: "20px" }}
                maxLength={3}
              />
            </Grid>
          </Grid>

          <Typography variant="h3" sx={{ fontWeight: "700", fontSize: "17px" }}>
            Billing Details
          </Typography>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              marginTop: "3px",
              marginBottom: "10px",
              color: "#848886",
            }}
          >
            Provide the details that you would like to appear on your invoice
          </Typography>

          <Label
            labelText="Account Type"
            labelProps={{ color: appcolors.black, fontWeight: 600 }}
          />
          <FormControl
            fullWidth
            sx={[globalStyle.selectType, { marginBottom: "12px" }]}
          >
            <Select
              displayEmpty
              variant="outlined"
              size="small"
              name="accountType"
              value={inputValues.accountType}
              onChange={handleChange}
            >
              <MenuItem value="individual">Individual / Self-employed</MenuItem>
              <MenuItem value="business">Business</MenuItem>
            </Select>
          </FormControl>

          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Label
                labelText="First name"
                labelProps={{ color: appcolors.black, fontWeight: 600 }}
              />
              <TextInput
                required
                placeholder="Enter your first name"
                name="firstName"
                value={inputValues.firstName}
                onChange={handleChange}
                style={{ marginBottom: "20px" }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Label
                labelText="Last name"
                labelProps={{ color: appcolors.black, fontWeight: 600 }}
              />
              <TextInput
                required
                placeholder="Enter your last name"
                name="lastName"
                value={inputValues.lastName}
                onChange={handleChange}
                style={{ marginBottom: "20px" }}
              />
            </Grid>
          </Grid>

          <Box sx={{ marginBottom: "15px" }}>
            <Label
              labelText="Address"
              labelProps={{ color: appcolors.black, fontWeight: 600 }}
            />
            <GooglePlacesAutocomplete
              apiKey="AIzaSyDgm3VBE9YF9fIYqHU6Cue4OfJBtJBlxj4"
              selectProps={{
                value: inputValues?.address
                  ? {
                      label: inputValues.address,
                      value: inputValues.address,
                    }
                  : null,
                onChange: (value) =>
                  setInputValues((prev) => ({ ...prev, address: value.label })),
              }}
            />
          </Box>

          <Label
            labelText="GAZT number"
            labelProps={{ color: appcolors.black, fontWeight: 600 }}
          />
          <TextInput
            required
            type="number"
            name="gaztNumber"
            value={inputValues.gaztNumber}
            onChange={handleChange}
            style={{ marginBottom: "20px" }}
            maxLength={3}
          />
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <GlobalButton
              btnText={type !== "add" ? "Update" : "Create"}
              styleProps={{ color: "#FFF" }}
              handleClickBtn={handleCreateBranch}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              border: "2px solid rgb(236 236 236)",
              borderRadius: "10px",
              padding: "24px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  padding: "10px",
                  background: appcolors.primary,
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={allIcons.calenderCheckIcon}
                  style={{
                    width: "25px",
                    height: "25px",
                    filter:
                      "brightness(0) saturate(100%) invert(99%) sepia(1%) saturate(3%) hue-rotate(3deg) brightness(114%) contrast(100%)",
                  }}
                />
              </Box>
              <Box sx={{ marginLeft: "10px" }}>
                <Typography
                  variant="h3"
                  sx={{ fontWeight: "700", fontSize: "16px" }}
                >
                  Online bookings
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: "400",
                    fontSize: "13px",
                    lineHeight: "20px",
                    color: "rgb(133 131 131)",
                  }}
                >
                  Take bookings on Loba marketplace
                </Typography>
              </Box>
            </Box>
            <Box sx={{ marginTop: "20px" }}>
              <Typography
                variant="h3"
                sx={{ fontWeight: "700", fontSize: "16px", lineHeight: "20px" }}
              >
                Online booking fees
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: "400",
                  fontSize: "13px",
                  lineHeight: "20px",
                  color: "rgb(133 131 131)",
                }}
              >
                4.90% + SA 0.75 per online transaction
              </Typography>
            </Box>
            <Box sx={{ marginTop: "20px" }}>
              <Typography
                variant="h3"
                sx={{ fontWeight: "700", fontSize: "16px", lineHeight: "20px" }}
              >
                50% new client fee
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: "400",
                  fontSize: "13px",
                  lineHeight: "20px",
                  color: "rgb(133 131 131)",
                }}
              >
                One-time commission, minimum 10
                <br />
                <br />
                Applied to brand new clients who discover your business via the
                Loba marketplace. The fee never applies to your returning
                clients.
                <br />
                <br />
                Rates are exclusive of 15% VAT
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EnableOnlineBookings;
